import React from 'react';
import { IShopDineAndRelaxPageData } from '../../domain/models/IShopDineAndRelaxPageData';
import { PoiOverview } from './PoiOverview';
import { useSetPoiResults } from './helpers/useSetPoiResults';
import { GenericPage } from '../../../app/pages/ui/GenericPage';

const ShopDineAndRelaxPage = ({ page, pois }: IShopDineAndRelaxPageData) => {
	useSetPoiResults(pois);

	return (
		<GenericPage page={page} overlapContentWithHeader>
			<PoiOverview />
		</GenericPage>
	);
};

export default ShopDineAndRelaxPage;
